<template>

    <div class="avatar-preview-container" :class=" smallOnly ? 'small-only' : 'small-and-full' ">

        <div class="avatar-preview user-avatar preview-full"
             v-if="!smallOnly && store.state.avatars && store.state.avatarFrames">
            <img :src="imageAvatarProfile" alt="Avatar de l'utilisateur" class="avatar" v-if=" imageAvatarProfile !== '' "/>
            <img :src="imageBorder" class="frame" v-if=" imageBorder !== '' "/>
        </div>

        <div class="avatar-preview user-avatar" v-if="store.state.avatars && store.state.avatarFrames">
            <img :src="imageAvatarProfile" alt="Aperçu de l'avatar de l'utilisateur" class="avatar" v-if=" imageAvatarProfile !== '' "/>
            <img :src="imageBorder" class="frame" v-if=" imageBorder !== '' "/>
        </div>

    </div>

</template>

<script>
export default {
    name : "PreviewAvatar",
}
</script>

<script setup>

import { computed } from "vue";
import { useStore } from "vuex";

let props = defineProps( [ "field", "data", "datastore", "smallOnly" ] );
let store = useStore();

let user    = computed( () => store.state.user );
let profile = computed( () => user.value.profile );
let ready   = computed( () => store.state.ready );

let imageAvatarProfile = computed( getImageAvatar );
let imageAvatarFull    = computed( getImageAvatarFull );
let imageBorder        = computed( getImageAvatarFrame );

let smallOnly = computed( () => props.smallOnly );


function getAvatar ()
{
    if ( !store.state.avatars )
    {
        return '';
    }

    let avatar = store.state.avatars.find( av => av.id === parseInt( user?.value[ "id_avatar" ] ?? false ) );
    if ( avatar < 1 )
    {
        avatar = store.state.avatars.find( av => av.id === store.state.defaultAvatarId );
    }


    return avatar;
}

function getImageAvatar ()
{

    if ( !store.state.avatars )
    {
        return '';
    }

    let avatar = store.state.avatars.find( av => av.id === parseInt( user?.value[ "id_avatar" ] ?? false ) );

    if ( ! avatar )
    {
        avatar = store.state.avatars.find( av => av.id === parseInt(store.state.defaultAvatarId) );
    }


    return avatar ? avatar.profileSizeUrl : '';
}

function getImageAvatarFull ()
{
    if ( !store.state.avatars)
    {
        return '';
    }

    let avatar = store.state.avatars.find( av => av.id === parseInt( user?.value[ "id_avatar" ] ?? false ) );
    if ( avatar < 1 )
    {
        avatar = store.state.avatars.find( av => av.id === parseInt(store.state.defaultAvatarId) );
    }

    return avatar ? avatar.fullSizeUrl : '';
}

function getImageAvatarFrame ()
{
    if ( !store.state.avatarFrames )
    {
        return '';
    }

    const avatarFrame = store.state.avatarFrames.find( av => av.id === parseInt( user?.value[ "id_frame" ] ?? false ) );

    return avatarFrame ? avatarFrame.url : '';
}

</script>

<style scoped>


</style>
